import axios from "axios";
import Cookies from "js-cookie";
import history from "../utils/history";

/**
 * Single axios instance for every authenticated CRM API call. Replaces the
 * old pattern of each services/*.js file re-implementing its own base URL,
 * auth header, and 401 handling by hand (and checking the wrong response
 * field for it - see clearAuthCookies below).
 */
// No default Content-Type here: axios already sets "application/json" for a
// plain object body, and letting the browser set its own multipart boundary
// for FormData bodies (file uploads) requires not pinning Content-Type at all.
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_PRO_MODE,
});

apiClient.interceptors.request.use((config) => {
  const token = Cookies.get("ClaccessToken");
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const clearAuthCookies = () => {
  document.cookie.split(";").forEach((cookie) => {
    const eqPos = cookie.indexOf("=");
    const name = (eqPos > -1 ? cookie.substr(0, eqPos) : cookie).trim();
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  });
};

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // The old per-service check was `error.response.data.statusCode === 401`,
    // but the backend's response envelope uses `code`, not `statusCode` - so
    // that check silently never matched. `error.response.status` is the
    // actual HTTP status axios always sets and is what should be checked.
    if (error?.response?.status === 401) {
      clearAuthCookies();
      if (history.location.pathname !== "/login") {
        history.push("/login");
      }
    }
    return Promise.reject(error);
  },
);

export default apiClient;
